<template>
  <div>
    <i title="Generate project Idea" style="float: right" @click="showPassionProjectRecommendationModal" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" class="fa-solid fa-lightbulb text-primary pointer fa-lg"></i>
    <b-modal
      v-model="showPassonProjectRecommendationModal"
      scrollable
      :title="cvPassionProjectRecommendationModalHeader"
      size="xxl"
      no-close-on-backdrop
      no-close-on-esc
      @show="disableBodyScroll"
      @hidden="onModalHidden"
    >
      <div class="modal-body">
        <div class="rounded rounded-2 bg-light mb-3">
          <div class="d-flex p-2 align-items-center">
            <i class="fas fa-info-circle text-primary" style="font-size: 20px; margin-right: 12px;"></i>
            <p class="mb-0 text-primary">
              Enter the student's interests, technical skills, academic strengths, achievements, certifications, and extracurricular activities. This information will help generate personalized passion project recommendations that align with their profile.
            </p>
          </div>
        </div>

        <!-- Student Interest -->
        <div class="col-md-12 mb-4">
          <label class="font-weight-bold mb-0">Student Interest & Skills</label>
          <small class="text-muted d-block mb-2">
            Include: interests, technical skills, academic strengths, achievements, certifications, and extracurricular activities
          </small>
          <textarea
            rows="4"
            v-model="vmPassionProjectFormData.student_interest"
            type="textarea"
            class="form-control"
            id="student_interest"
            placeholder="E.g., Interested in coding and problem-solving, enjoys building websites and mobile apps, Python, JavaScript, HTML/CSS, Won 2nd prize in school science fair for IoT project, Participated in coding competitions, Member of school robotics club, scored 95% in Mathematics..."
            autogrow
            @input="onStudentInterestChange"
            ></textarea>
          <small class="text-muted d-block mt-1">
            Minimum 150 characters required.
            <strong> {{ vmPassionProjectFormData.student_interest.length }}</strong> / 150 characters
          </small>
          <label class="text-danger" v-if="errorMessage.student_interest">{{ errorMessage.student_interest }}</label>
        </div><!-- Student Interest -->

        <!-- Student class -->
        <div class="col-md-12 mb-4">
          <label class="font-weight-bold mb-0">Student Class</label>
          <small class="text-muted d-block mb-2">
            Enter the current class/grade of the student
          </small>
          <input
            v-model="vmPassionProjectFormData.student_class"
            placeholder="E.g., 9, 10, 11, 12, etc."
            class="form-control"
            @input="onStudentClassChange"
          />
          <label class="text-danger" v-if="errorMessage.student_class">{{ errorMessage.student_class }}</label>
        </div><!-- Student Class -->

        <button v-if="!Array.isArray(passionProjectResponseList) && passionProjectResponseList?.length !== 0" :disabled="isLoadingPassionProject" type="button" class="btn btn-primary" @click="getPassionProjectRecommendation()">
          {{ cvGetRecoBtn }}
        </button>

        <!-- passion project list -->
        <div style="min-height: 300px;" class="py-4 passion-project-list-container">
          <div v-if="isLoadingPassionProject" class="d-flex flex-column align-items-center justify-content-center mt-4">
            <div class="spinner-border" role="status" aria-hidden="true"></div>
            <strong class="mt-2 text-center">Generating Passion Project Recommendations, please wait...</strong>
          </div>
          <div v-else-if="passionProjectResponseList && Array.isArray(passionProjectResponseList) && passionProjectResponseList?.length">
            <h5 class="mt-4 text-center">Recommended Passion Projects</h5>
            <div class="row justify-content-center mt-3">
              <div
                v-for="(project, index) in passionProjectResponseList"
                :key="index"
                class="col-12 col-lg-6 col-xl-4 d-flex justify-content-center mb-4"
              >
                <b-card class="shadow-lg border-0 w-100 passion-card">
                  <!-- Title -->
                  <b-card-title class="d-flex justify-content-between">
                    <p class="font-weight-bold text-start mb-2 mr-2">{{ project.title }}</p>
                    <span class="action-icon text-success" @click="viewBlog(project)" title="View Blog Content">
                      <i class="fas fa-eye fa-lg"></i>
                    </span>
                  </b-card-title>
                  <!-- Description -->
                  <b-card-text class="text-muted text-center">{{ project.description }}</b-card-text>
                  <!-- Buttons -->
                  <div class="d-flex justify-content-center align-items-center mt-3 px-2">
                    <b-button title="Recommend Activity" :disabled="addingProjectIndex !== null" @click="profBuildRecoNotesAdd(project, index)" variant="primary">
                      {{addingProjectIndex === index ? "Adding..." : "Add Recommendation"}}
                      <div v-if="addingProjectIndex === index" style="width: 1rem; height: 1rem;" class="spinner-border" role="status" aria-hidden="true"></div>
                      <i v-else class="fa-solid fa-heart-circle-plus m-0 font-size-20" aria-hidden="true"></i>
                    </b-button>
                  </div>
                </b-card>
              </div>
            </div>
            <div v-if="passionProjectResponseList?.length < 9" class="py-4 d-flex flex-column align-items-center justify-content-center">
              <p><strong>Did not like any of the suggestions?</strong> Tweak the student’s interest to get better recommendations.</p>
              <b-button variant="primary" class="btn btn-primary" @click="getPassionProjectRecommendation()">Regenerate More Recommendations</b-button>
            </div>
          </div>
          <div v-else-if="!isLoadingPassionProject && Array.isArray(passionProjectResponseList) && passionProjectResponseList?.length === 0" class="d-flex flex-column align-items-center justify-content-center mt-4">
            <p>Something went wrong. Please try again.</p>
            <b-button variant="primary" class="btn btn-primary" @click="handleTryAgain">Try Again</b-button>
          </div>
        </div>
        <!-- passion project list -->
        <!-- Gide BLog View -->
        <b-modal
          v-model="showBlogModal"
          scrollable
          :title="cvViewModalHeader"
          size="xxl"
        >
          <gideBlogView :propOpenedInModal="true" :propBlogVueObj="selectedProject"/>
          <template #modal-footer="">
            <b-button size="sm" @click="closeblogViewModal()">
              {{cvbtnModalCancel}}
            </b-button>
          </template>
        </b-modal><!-- Gide BLog View -->
      </div>
      <template #modal-footer="">
        <b-button size="sm" @click="closePassionProjectRecommendationModal">
            {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </div>
</template>
<script>
import { GPathrRoadmapExtras } from "../../../FackApi/api/GPathrRoadmapExtra"
import { SpcmNotess } from "../../../FackApi/api/spcmNotes"
import ApiResponse from "../../../Utils/apiResponse"
import GideBlogView from "../../Public/GideBlogView.vue"

export default {
  name: "PassionProjectRecommendationModal",
  components: {
    GideBlogView
  },
  data () {
    return {
      showPassonProjectRecommendationModal: false,
      cvPassionProjectRecommendationModalHeader: "Generate Passion Project Recommendation",
      cvbtnModalCancel: "Cancel",
      showToast: false,
      toastMsg: null,
      toastTitle: "Passion Project",
      toastVariant: "default",
      vmPassionProjectFormData: {
        student_interest: "",
        student_class: "",
        previous_generated_titles: ""
      },
      errorMessage: {
        student_interest: "",
        student_class: ""
      },
      cvGetRecoBtn: "Get Reco",
      passionProjectResponseList: null,
      isLoadingPassionProject: false,
      showBlogModal: false,
      selectedProject: null,
      addingProjectIndex: null,
      timeoutId: null,
      isDataFetchedFromGpathRoadmapExtra: false,
      cvViewModalHeader: "Project Execution Plan Blog View"
    }
  },
  props: {
    propSpcmObj: {
      default: null,
      type: Object
    },
    propEducationList: {
      default: null,
      type: Array
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    passionProjectResponse () {
      return this.$store.getters["SpcmNotes/getPassionProjectResponse"]
    }
  },
  methods: {
    onStudentInterestChange () {
      if (this.errorMessage.student_interest && this.vmPassionProjectFormData.student_interest.length >= 150) {
        this.errorMessage.student_interest = ""
      }
    },
    onStudentClassChange () {
      if (this.errorMessage.student_class) {
        this.errorMessage.student_class = ""
      }
    },
    /**
     * scrollToProjectList
     * Scroll modal body
     */
    scrollToProjectList () {
      this.$nextTick(() => {
        const projectListContainer = document.querySelector(".passion-project-list-container")

        if (!projectListContainer) return

        // smooth scroll
        if ("scrollIntoView" in projectListContainer) {
          projectListContainer.scrollIntoView({
            behavior: "smooth",
            block: "start"
          })
        }
        else {
          // Fallback for older browsers
          const modalBody = document.querySelector(".modal-body")
          if (modalBody) {
            const scrollTop = projectListContainer.offsetTop - 100
            modalBody.scrollTop = scrollTop
          }
        }
      })
    },
    /**
     * onModalHidden
     * Handle the modal hidden event
     */
    onModalHidden () {
      this.enableBodyScroll()
      this.closePassionProjectRecommendationModal()
    },
    /**
     * spcmPassionProjectProfileSummaryView
     */
    async spcmPassionProjectProfileSummaryView () {
      const payload = {
        user_id: this.propSpcmObj.user_id ? this.propSpcmObj.user_id : this.$route.query.user_id,
        yjsdocs_code: "15" // uexcc_type_id is 15 for `uexcc_type_key` = "PROFILESUMMARY"
      }
      try {
        let yjsdocsData = await SpcmNotess.spcmPassionProjectProfileSummaryView(this, payload)
        if (yjsdocsData.resp_status) {
          if (yjsdocsData.resp_data.data.yjsdocs) {
            this.vmPassionProjectFormData.student_interest = yjsdocsData.resp_data.data.yjsdocs
          }
        }
      }
      catch (error) {
        console.error("Error fetching spcmPassionProjectProfileSummaryView:", error)
      }
    },
    /**
     * showPassionProjectRecommendationModal
     */
    showPassionProjectRecommendationModal () {
      this.showPassonProjectRecommendationModal = true
      this.spcmPassionProjectProfileSummaryView()
    },
    /**
     * closePassionProjectRecommendationModal
     */
    closePassionProjectRecommendationModal () {
      // Reset form on close
      this.vmPassionProjectFormData = {
        student_interest: "",
        student_class: "",
        previous_generated_titles: ""
      }
      this.errorMessage = {
        student_interest: "",
        student_class: ""
      }

      // reset recommendation list
      this.passionProjectResponseList = null

      // reset data fetched flag
      this.isDataFetchedFromGpathRoadmapExtra = false

      this.$emit("emitClosePassionProjectRecommendationModal")
      this.showPassonProjectRecommendationModal = false
    },
    /**
     * disableBodyScroll
     * Disable body scroll when modal opens
     */
    disableBodyScroll () {
      document.body.style.overflow = "hidden"
    },
    /**
     * enableBodyScroll
     * Enable body scroll when modal closes
     */
    enableBodyScroll () {
      document.body.style.overflow = "auto"
    },
    /**
    * getHighestEducation
    * Get the highest education from the education list based on class_name
    */
    getHighestEducation (propEducationList) {
      if (!Array.isArray(propEducationList) || propEducationList.length === 0) {
        return null
      }

      let highest = propEducationList[0]

      for (let i = 1; i < propEducationList.length; i++) {
        const currentClass = Number(propEducationList[i]?.education?.class_name) || 0
        const highestClass = Number(highest?.education?.class_name) || 0

        if (currentClass > highestClass) {
          highest = propEducationList[i]
        }
      }

      return highest
    },
    /**
     * getPassionProjectRecommendation
     * 1. save student_interest/ student summary in user_profile_exc
     * 2. generate 3 passion project based on user interest and show on the UI
     */
    async getPassionProjectRecommendation () {
      // Validate inputs
      this.errorMessage.student_interest = ""
      this.errorMessage.student_class = ""

      if (!this.vmPassionProjectFormData.student_interest || this.vmPassionProjectFormData.student_interest.length < 150) {
        this.errorMessage.student_interest = "Please provide at least 150 characters describing student's interests and skills."
        return
      }

      if (!this.vmPassionProjectFormData.student_class || this.vmPassionProjectFormData.student_class.trim() === "") {
        this.errorMessage.student_class = "Please enter the student's class/grade."
        return
      }
      try {
        this.isLoadingPassionProject = true
        const highestEducation = this.getHighestEducation(this.propEducationList)
        // showing toast if class is lower or higher
        if (highestEducation && highestEducation?.education?.class_name) {
          if (Number(this.vmPassionProjectFormData.student_class) < Number(highestEducation?.education?.class_name)) {
            this.showToast = true
            this.toastMsg = "Generating passion project recommendations. The entered student class is lower than the highest education class in the profile. Please tell the student to update their class."
          }
          else if (Number(this.vmPassionProjectFormData.student_class) > Number(highestEducation?.education?.class_name)) {
            this.showToast = true
            this.toastMsg = "Generating passion project recommendations. The entered student class is higher than the highest education class in the profile. Please tell the student to update their class."
          }
        }

        // Add previous generated comma separated titles to the form data
        if (this.passionProjectResponseList && Array.isArray(this.passionProjectResponseList) && this.passionProjectResponseList.length > 0) {
          this.vmPassionProjectFormData.previous_generated_titles = this.passionProjectResponseList.map(project => project.title).join(", ")
        }

        this.vmPassionProjectFormData.gide_user_id = this.propSpcmObj.user_id ? this.propSpcmObj.user_id : this.$route.query.user_id
        const generatePassionProjectsResponse = await SpcmNotess.spcmGeneratePassionProjects(this, this.vmPassionProjectFormData)
        if (!generatePassionProjectsResponse.resp_status) {
          this.showToast = true
          this.toastMsg = "Failed to generate Passion Project Recommendations. Please try again."
          this.toastVariant = "danger"
          this.isLoadingPassionProject = false
          this.passionProjectResponseList = []
          return
        }

        // Wait for socket response with 1.5 minutes timeout
        this.timeoutId = setTimeout(() => {
          this.isLoadingPassionProject = false
          this.passionProjectResponseList = []

          this.showToast = true
          this.toastMsg = "Failed to generate passion projects. Please try again."
          this.toastVariant = "danger"
        }, 90000)
      }
      catch (error) {
        console.error("Error fetching passion project recommendation:", error)
        this.showToast = true
        this.toastMsg = "Error fetching passion project recommendation. Please try again."
        this.toastVariant = "danger"
        this.isLoadingPassionProject = false
        this.passionProjectResponseList = []
      }
    },
    /**
     * profBuildRecoNotesAdd
     */
    async profBuildRecoNotesAdd (pbaObj, projectIndex) {
      this.addingProjectIndex = projectIndex
      try {
        let payload = {
          session_title: "Passion Project",
          spcm_id: this.propSpcmObj.spcm_id ? this.propSpcmObj.spcm_id : this.$route.query.spcm_id,
          note_type: 4,
          note_desc: JSON.stringify({
            title: pbaObj.title,
            description: pbaObj.description,
            url: pbaObj.url
          }),
          note_public_type: 1,
          notes_module_obj_id: this.propSpcmObj.user_id ? this.propSpcmObj.user_id : this.$route.query.user_id,
          counsellor_id: this.userData.user_id,
          gide_user_id: this.propSpcmObj.user_id ? this.propSpcmObj.user_id : this.$route.query.user_id,
          session_id: "dummy_session_id",
          class: this.vmPassionProjectFormData?.student_class
        }

        let spcmProfBuildNotesAddResp = await SpcmNotess.spcmNotesAdd(this, payload)
        if (spcmProfBuildNotesAddResp.resp_status) {
          this.toastMsg = "Profile building activity added"
          this.toastVariant = "success"
          this.showToast = true
          this.addingProjectIndex = null
          // this.$emit("emitClosePassionProjectRecommendationModal")
        }
        else {
          ApiResponse.responseMessageDisplay(this, spcmProfBuildNotesAddResp)
          this.addingProjectIndex = null
        }
      }
      catch (err) {
        console.error("Exception in profBuildRecoNotesAdd and err: ", err.message)
        this.addingProjectIndex = null
      }
    },
    /**
    * viewBlog
    * Show blog content modal
    */
    viewBlog (project) {
      this.selectedProject = project
      if (project?.url) {
        const blogId = project.url.split("blog_view/")[1]
        this.selectedProject.blog_id = blogId
      }
      this.showBlogModal = true
    },
    /**
     * gpathRoadmapExtraList
     */
    async gpathRoadmapExtraList () {
      this.isLoadingPassionProject = true

      let gpathRoadmapExtraListPayload = {
        gide_user_id: this.propSpcmObj.user_id ? this.propSpcmObj.user_id : this.$route.query.user_id,
        name_key: "passion_project"
      }
      try {
        let gpathRoadmapExtraListResp = await GPathrRoadmapExtras.gpathRoadmapExtraList(this, gpathRoadmapExtraListPayload)
        if (gpathRoadmapExtraListResp.resp_status) {
          this.passionProjectResponseList = gpathRoadmapExtraListResp.resp_data.data
          this.scrollToProjectList()
        }
        else {
          this.showToast = true
          this.toastMsg = "Failed to generate passion projects. Please try again."
          this.toastVariant = "danger"
          this.passionProjectResponseList = []
          this.isDataFetchedFromGpathRoadmapExtra = true
        }
      }
      catch (err) {
        console.log("Exception occurred at gpathRoadmapExtraList() and Exception:", err.message)
        this.showToast = true
        this.toastMsg = "Error fetching passion project recommendations. Please try again."
        this.toastVariant = "danger"
        this.passionProjectResponseList = []
        this.isDataFetchedFromGpathRoadmapExtra = true
      }
      finally {
        this.isLoadingPassionProject = false
      }
    },
    /**
    * handleTryAgain
    * Handle try again button click after failure in generating passion projects
    */
    handleTryAgain () {
      if (this.isDataFetchedFromGpathRoadmapExtra) {
        this.getPassionProjectRecommendation()
      }
      else {
        this.gpathRoadmapExtraList()
      }
    }
  },
  watch: {
    /**
     * passionProjectResponse
     */
    passionProjectResponse (newVal) {
      if (!newVal || !newVal.passion_project_response) {
        return
      }

      // Parse the passion_project_response string if it's a JSON string
      let projectList = newVal.passion_project_response
      if (typeof projectList === "string") {
        try {
          projectList = JSON.parse(projectList)
        }
        catch (e) {
          console.error("Error parsing passion_project_response:", e)
          return
        }
      }

      // Store the parsed response list
      if (!Array.isArray(this.passionProjectResponseList)) {
        this.passionProjectResponseList = []
      }
      this.passionProjectResponseList = [...this.passionProjectResponseList, ...projectList]

      // Show toast notification
      this.showToast = true
      this.toastMsg = "Passion projects generated successfully!"
      this.toastVariant = "success"
      this.toastTitle = "Passion Projects"

      // Stop loading indicator
      this.isLoadingPassionProject = false

      // clear setTimeout
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }

      // Reset data fetched flag
      this.isDataFetchedFromGpathRoadmapExtra = false

      this.scrollToProjectList()

      // Clear the response from store
      this.$store.dispatch("SpcmNotes/removePassionProjectResponse")
    }
  }
}
</script>
<style scoped>
.passion-card {
  border-radius: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  min-height: 220px;
  padding: 12px;
}
.passion-card .card-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.passion-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.action-icon {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.action-icon:hover {
  transform: scale(1.2);
}
</style>
